import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { mergeMap } from 'rxjs/operators';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { RoutingRuleTranslator } from '../routingRule.translator';
import { RoutingRuleAction } from '../routingRule.action';

type IDependencies = IClientApiDependencySegment;

export const updateRoutingRuleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(RoutingRuleAction.update.started),
  mergeMap((params) => {
    const rules = params.map(RoutingRuleTranslator.toApi);
    return dependencies.api.updateRoutingRules({ rules }).pipe(
      mergeMap(() => {
        return [
          RoutingRuleAction.update.done({ params, result: [] }),
        ];
      }),
      catchApiError((error) => {
        return [
          RoutingRuleAction.update.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
